function formatData(data) {
  return format(data);
}
function format(data) {
  if (typeof data === "string") {
    return isEmail(data) ? data : data.toUpperCase();
  } else if (typeof data === "boolean") {
    return data ? "TRUE" : "FALSE";
  } else if (typeof data === "number") {
    return data.toString();
  }
  if (Array.isArray(data)) {
    return data.filter((v) => v !== null && v !== void 0).map((a) => format(a));
  } else if (typeof data === "object" && data !== null) {
    const entries = Object.entries(data).filter(([, value]) => value !== null && value !== void 0).map(([key, value]) => {
      if (isBazaarvoice(key) || isEmail(value))
        return [key, value];
      return [key, format(value)];
    });
    return Object.fromEntries(entries);
  }
  return "";
}
function isBazaarvoice(key) {
  return key.startsWith("bv_");
}
function isEmail(email) {
  return /\S+@\S+\.\S+/.test(email);
}
export {
  format,
  formatData
};
//# sourceMappingURL=utag-data.js.map
